import { render, staticRenderFns } from "./BangGiaQuangCaoForm.vue?vue&type=template&id=33ed3daa"
import script from "./BangGiaQuangCaoForm.vue?vue&type=script&lang=js"
export * from "./BangGiaQuangCaoForm.vue?vue&type=script&lang=js"
import style0 from "./BangGiaQuangCaoForm.vue?vue&type=style&index=0&id=33ed3daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports